import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Mitel } from './components/Mitel';
import CacheBuster from 'react-cache-buster';
import { version } from '../package.json';
import './App.css';

function App() {
  return (
    <CacheBuster currentVersion={version}>
      <BrowserRouter>
        <Routes>
          <Route path="/mitel" element={<Mitel />} />
        </Routes>
      </BrowserRouter>
    </CacheBuster>
  );
}

export default App;
